export const COST_CENTERS_LIST_DEFAULT_PAGE_SIZE = 50;
